import { Link } from 'react-router-dom';
import { useState } from "react";
import logo from '../../../assets/images/resources/ramana-steel-logo1.png';

const MobileNav = ({ isSidebar, handleMobileMenu, handleSidebar }) => {
  const [isActive, setIsActive] = useState({
    status: false,
    key: "",
    subMenuKey: "",
  });

  const handleToggle = (key, subMenuKey = "") => {
    if (isActive.key === key && isActive.subMenuKey === subMenuKey) {
      setIsActive({
        status: false,
        key: "",
        subMenuKey: "",
      });
    } else {
      setIsActive({
        status: true,
        key,
        subMenuKey,
      });
    }
  };

  return (
    <>
      <div className="mobile-nav__wrapper">
        <div
          className="mobile-nav__overlay mobile-nav__toggler"
          onClick={handleMobileMenu}
        />
        <div className="mobile-nav__content">
          <span
            className="mobile-nav__close mobile-nav__toggler"
            onClick={handleMobileMenu}
          >
            <i className="fa fa-times" />
          </span>
          <div className="logo-box">
            <Link to="/" aria-label="logo image">
              <img src={logo} width="150" alt="Logo" />
            </Link>
          </div>
          <div className="mobile-nav__container">
            <ul className="main-menu__list">
              <li>  <Link to="/" onClick={handleMobileMenu}>Home</Link></li>
              <li><Link to="/about" onClick={handleMobileMenu}>About Us</Link></li>
              {/* <li className={isActive.key === "home" ? "dropdown current" : "dropdown"}>
                <Link to="/" onClick={handleMobileMenu}>Home</Link>
                <ul style={{ display: `${isActive.key === "home" ? "block" : "none"}` }}>
                  <li><Link to="/" onClick={handleMobileMenu}>Home One</Link></li>
                  <li><Link to="/index-2" onClick={handleMobileMenu}>Home Two</Link></li>
                  <li><Link to="/index-3" onClick={handleMobileMenu}>Home Three</Link></li>
                  <li><Link to="/index-4" onClick={handleMobileMenu}>Home Four</Link></li>
                  <li className={isActive.subMenuKey === "header-styles" ? "dropdown current" : "dropdown"}>
                    <Link to="#" onClick={() => handleToggle("home", "header-styles")}>Header Styles</Link>
                    <ul style={{ display: `${isActive.subMenuKey === "header-styles" ? "block" : "none"}` }}>
                      <li><Link to="/" onClick={handleMobileMenu}>Header One</Link></li>
                      <li><Link to="/index-2" onClick={handleMobileMenu}>Header Two</Link></li>
                      <li><Link to="/index-3" onClick={handleMobileMenu}>Header Three</Link></li>
                      <li><Link to="/index-4" onClick={handleMobileMenu}>Header Four</Link></li>
                    </ul>
                    <div className={isActive.subMenuKey === "header-styles" ? "dropdown-btn open" : "dropdown-btn"} onClick={() => handleToggle("home", "header-styles")}>
                      <span className="fa fa-angle-right" />
                    </div>
                  </li>
                </ul>
                <div className={isActive.key === "home" ? "dropdown-btn open" : "dropdown-btn"} onClick={() => handleToggle("home")}>
                  <span className="fa fa-angle-right" />
                </div>
              </li>
              
              <li className={isActive.key === "pages" ? "dropdown current" : "dropdown"}>
                <Link to="#" onClick={() => handleToggle("pages")}>Pages</Link>
                <ul style={{ display: `${isActive.key === "pages" ? "block" : "none"}` }}>
                  <li><Link to="/team" onClick={handleMobileMenu}>Team</Link></li>
                  <li><Link to="/team-details" onClick={handleMobileMenu}>Team Details</Link></li>
                  <li><Link to="/testimonials" onClick={handleMobileMenu}>Testimonials</Link></li>
                  <li><Link to="/faq" onClick={handleMobileMenu}>Faq</Link></li>
                  <li><Link to="/404" onClick={handleMobileMenu}>404 Error</Link></li>
                </ul>
                <div className={isActive.key === "pages" ? "dropdown-btn open" : "dropdown-btn"} onClick={() => handleToggle("pages")}>
                  <span className="fa fa-angle-right" />
                </div>
              </li> */}
              <li className={isActive.key === "services" ? "dropdown current" : "dropdown"}>
                <Link to="#" onClick={() => handleToggle("services")}>Our Products</Link>
                <ul style={{ display: `${isActive.key === "services" ? "block" : "none"}` }}>
                  <li><Link to="/products" onClick={handleMobileMenu}>All Products</Link></li>
                  <li><Link to="/movable-excavator" onClick={handleMobileMenu}>Movable Excavator</Link></li>
                  <li><Link to="/scrap-magnet" onClick={handleMobileMenu}>Scrap Magnet</Link></li>
                  <li><Link to="/vertical-scrap-shear" onClick={handleMobileMenu}>Vertical Heavy Duty Scrap Shearing Machine</Link></li>
                  <li><Link to="/fixed-boom-excavator" onClick={handleMobileMenu}>Fixed Boom Excavator</Link></li>
                  <li><Link to="/hydraulic-scrap-baler" onClick={handleMobileMenu}>Hydraulic Scrap Baler</Link></li>
                  <li><Link to="/horizontal-automatic-container-shear" onClick={handleMobileMenu}>Horizontal Automatic Container Shearing Machine</Link></li>
                  <li><Link to="/grabber" onClick={handleMobileMenu}>SCRAP GRABBER</Link></li>
                </ul>
                <div className={isActive.key === "services" ? "dropdown-btn open" : "dropdown-btn"} onClick={() => handleToggle("services")}>
                  <span className="fa fa-angle-right" />
                </div>
              </li>
              {/* <li className={isActive.key === "projects" ? "dropdown current" : "dropdown"}>
                <Link to="#" onClick={() => handleToggle("projects")}>Projects</Link>
                <ul style={{ display: `${isActive.key === "projects" ? "block" : "none"}` }}>
                  <li><Link to="/project" onClick={handleMobileMenu}>Projects</Link></li>
                  <li><Link to="/project-details" onClick={handleMobileMenu}>Project Details</Link></li>
                </ul>
                <div className={isActive.key === "projects" ? "dropdown-btn open" : "dropdown-btn"} onClick={() => handleToggle("projects")}>
                  <span className="fa fa-angle-right" />
                </div>
              </li> */}
              {/* <li className={isActive.key === "blog" ? "dropdown current" : "dropdown"}>
                <Link to="#" onClick={() => handleToggle("blog")}>Blog</Link>
                <ul style={{ display: `${isActive.key === "blog" ? "block" : "none"}` }}>
                  <li><Link to="/blog" onClick={handleMobileMenu}>Blog</Link></li>
                  <li><Link to="/blog-list" onClick={handleMobileMenu}>Blog List</Link></li>
                  <li><Link to="/blog-details" onClick={handleMobileMenu}>Blog Details</Link></li>
                </ul>
                <div className={isActive.key === "blog" ? "dropdown-btn open" : "dropdown-btn"} onClick={() => handleToggle("blog")}>
                  <span className="fa fa-angle-right" />
                </div>
              </li> */}
              <li><Link to="/contact" onClick={handleMobileMenu}>Contact Us</Link></li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default MobileNav;
